<template>
  <div class="login-page">
    <div class="login-container">
      <div class="login-card">
        <div class="login-header">
          <div class="logo">🔐</div>
          <h1 class="title">Админ-панель</h1>
          <p class="subtitle">Мир Потолков</p>
        </div>

        <form @submit.prevent="handleLogin" class="login-form">
          <div class="form-group">
            <label for="username">Логин</label>
            <input
              id="username"
              v-model="username"
              type="text"
              placeholder="Введите логин"
              class="form-input"
              autocomplete="username"
              required
            />
          </div>

          <div class="form-group">
            <label for="password">Пароль</label>
            <input
              id="password"
              v-model="password"
              type="password"
              placeholder="Введите пароль"
              class="form-input"
              autocomplete="current-password"
              required
            />
          </div>

          <div v-if="error" class="error-message">
            ⚠️ {{ error }}
          </div>

          <button type="submit" class="btn-login" :disabled="loading">
            {{ loading ? 'Вход...' : 'Войти' }}
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import axios from 'axios'
import { usePermissions } from '@/composables/usePermissions'

const API_BASE = 'https://mpapi.premside.uz/api/auth'

export default {
  name: 'LoginPage',
  setup() {
    const router = useRouter()
    const { loadUserPermissions } = usePermissions()
    const username = ref('')
    const password = ref('')
    const loading = ref(false)
    const error = ref(null)

    const handleLogin = async () => {
      error.value = null
      loading.value = true

      try {
        const response = await axios.post(`${API_BASE}/login`, {
          username: username.value,
          password: password.value
        })

        const { token, user } = response.data

        // Сохраняем токен и данные пользователя
        localStorage.setItem('auth_token', token)
        localStorage.setItem('user', JSON.stringify(user))

        // Настраиваем axios для использования токена
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`

        // Загружаем права пользователя
        await loadUserPermissions()

        // Переходим в админ-панель
        router.push('/admin')
      } catch (err) {
        console.error('Login error:', err)
        error.value = err.response?.data?.message || 'Неверный логин или пароль'
      } finally {
        loading.value = false
      }
    }

    return {
      username,
      password,
      loading,
      error,
      handleLogin
    }
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.login-container {
  width: 100%;
  max-width: 420px;
  padding: 1.5rem;
}

.login-card {
  background: white;
  border-radius: 0.75rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  border: 1px solid #e5e7eb;
}

.login-header {
  text-align: center;
  padding: 2rem 1.5rem 1.75rem;
  background: #ffffff;
  color: #1f2937;
  border-bottom: 1px solid #e5e7eb;
}

.logo {
  font-size: 2.5rem;
  margin-bottom: 0.5rem;
}

.title {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 0.25rem;
  color: #111827;
}

.subtitle {
  font-size: 0.875rem;
  color: #6b7280;
}

.login-form {
  padding: 1.75rem 1.5rem;
}

.form-group {
  margin-bottom: 1.25rem;
}

.form-group label {
  display: block;
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.5rem;
  font-size: 0.813rem;
}

.form-input {
  width: 100%;
  box-sizing: border-box;
  padding: 0.625rem 0.875rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  transition: all 0.2s;
  color: #1f2937;
}

.form-input:focus {
  outline: none;
  border-color: #9ca3af;
  box-shadow: 0 0 0 3px rgba(156, 163, 175, 0.1);
}

.error-message {
  padding: 0.75rem 0.875rem;
  background: #fee2e2;
  border: 1px solid #fecaca;
  border-radius: 0.375rem;
  color: #991b1b;
  font-size: 0.813rem;
  margin-bottom: 1.25rem;
  text-align: center;
}

.btn-login {
  width: 100%;
  padding: 0.75rem;
  background: #1f2937;
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-login:hover:not(:disabled) {
  background: #111827;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.btn-login:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (max-width: 480px) {
  .login-container {
    padding: 1rem;
    max-width: 95%;
  }

  .login-header {
    padding: 1.5rem 1.25rem 1.25rem;
  }

  .login-form {
    padding: 1.5rem 1.25rem;
  }
}
</style>
